import React from 'react'

export default function Footer() {
  return (
    <footer class="bg-[#240046]">
        <div class="w-full mx-auto p-4 flex items-center justify-center">
            <span class="text-md text-[#ff9e03] sm:text-center ">© 2023  All Rights Reserved.
            </span>
        </div>
    </footer>
  )
}
